/**
 * Kinds of menus that can be open with an Ask input.
 */
export var ASK_INPUT_MENU;
(function (ASK_INPUT_MENU) {
    /** The focus menu. */
    ASK_INPUT_MENU[ASK_INPUT_MENU["FOCUS"] = 0] = "FOCUS";
    /** The sources menu for enterprise users or spaces users. */
    ASK_INPUT_MENU[ASK_INPUT_MENU["SOURCES"] = 1] = "SOURCES";
    /** The pro model preference selector menu. */
    ASK_INPUT_MENU[ASK_INPUT_MENU["PRO_MODEL_PREFERENCE"] = 2] = "PRO_MODEL_PREFERENCE";
    /** The attachments menu. */
    ASK_INPUT_MENU[ASK_INPUT_MENU["ATTACHMENTS"] = 3] = "ATTACHMENTS";
    /**
     * The unified source menu with sources and attachements
     */
    ASK_INPUT_MENU[ASK_INPUT_MENU["UNIFIED_SOURCES"] = 4] = "UNIFIED_SOURCES";
    /** The sidecar attachments menu (file upload + screenshot). */
    ASK_INPUT_MENU[ASK_INPUT_MENU["SIDECAR_ATTACHMENTS"] = 5] = "SIDECAR_ATTACHMENTS";
    /**
     * Search model menu
     */
    ASK_INPUT_MENU[ASK_INPUT_MENU["SEARCH_MODEL_MENU"] = 6] = "SEARCH_MODEL_MENU";
    /**
     * The plus menu (attachments, search modes, sources combined)
     */
    ASK_INPUT_MENU[ASK_INPUT_MENU["PLUS_MENU"] = 7] = "PLUS_MENU";
    /**
     * The sources menu
     */
    ASK_INPUT_MENU[ASK_INPUT_MENU["SOURCES_MENU"] = 8] = "SOURCES_MENU";
    /**
     * The Computer command menu attached to the ask input.
     */
    ASK_INPUT_MENU[ASK_INPUT_MENU["COMPUTER_COMMAND_MENU"] = 9] = "COMPUTER_COMMAND_MENU";
})(ASK_INPUT_MENU || (ASK_INPUT_MENU = {}));
//# sourceMappingURL=askInputMenu.js.map